/**
 * This functionality add event trigger for Canvas External Links Popup
 */
import {isExternalLinkWithFileCheck, isLinkExternal, isLinkNotInWhiteList} from '../../../lib/linkHandler.ts';

const pmiExternalLinkPopupEventTrigger = ({ name, data }) => {
  document.dispatchEvent(
    new CustomEvent('pmiExternalLinkPopup', {
      detail: { name, ...data },
    }),
  );
};

const pmiExternalLinkEventTrigger = ({ data }) => {
  document.dispatchEvent(
    new CustomEvent('pmiExternalLinkNoPopup', {
      detail: { ...data },
    }),
  );
};

function handleExternalLinkClick(data) {
  if (window.externalLink && window.externalLink.showModal) {
    pmiExternalLinkPopupEventTrigger({
      name: 'Open',
      data,
    });

    const externalWindowContinueButton = document.querySelector(
      '#external-link-modal button.btn-primary',
    );
    const externalWindowCloseButton = document.querySelector(
      '#external-link-modal button.btn-secondary',
    );

    function externalModalButtonContinueListener() {
      pmiExternalLinkPopupEventTrigger({ name: 'Continue', data });

      externalWindowContinueButton.removeEventListener(
        'click',
        externalModalButtonContinueListener,
      );
    }

    function externalModalButtonCloseListener() {
      externalWindowCloseButton.removeEventListener('click', externalModalButtonCloseListener);

      if (!!externalWindowContinueButton) {
        externalWindowContinueButton.removeEventListener(
          'click',
          externalModalButtonContinueListener,
        );
      }
    }

    if (!!externalWindowContinueButton) {
      externalWindowContinueButton.addEventListener(
        'click',
        externalModalButtonContinueListener,
        { once: true },
      );
    }

    if (!!externalWindowCloseButton) {
      externalWindowCloseButton.addEventListener('click', externalModalButtonCloseListener, {
        once: true,
      });
    }
  } else if (isExternalLinkWithFileCheck(data.href)) {
    pmiExternalLinkEventTrigger({
      data,
    });
  }
}

/**
 * Listen for chat links click events (triggered by "site-files/assets/einstein-bot-input-controller.js")
 *
 * Modifies the click method of anchor elements when they are created programmatically and the click() method is invoked programmatically.
 * This does not impact links that are part of the DOM and clicked by the user.
 */
window.addEventListener('onEmbeddedMessageLinkClicked', function(event) {
  // Do not do anything if the externalLink library is not available
  if (window.externalLink && window.externalLink.showModal) {
    const originalClick = HTMLAnchorElement.prototype.click;

    HTMLAnchorElement.prototype.click = function (event) {
      const href = this.getAttribute('href') || this.href;

      // Only show modal if the link is external
      const whitelist = window.externalLink?.primaryPopup?.whitelist.split('\n');
      if (whitelist && isLinkExternal(href) && isLinkNotInWhiteList(href, whitelist)) {
        window.externalLink.showModal(href);
        // Delay triggering the analytics event handler by one second to ensure the modal is visible before execution.
        setTimeout(() => {
          handleExternalLinkClick({ title: this.innerText || href, href });
        }, 1000);

        // Prevent opening the link. The modal will handle the opening.
        event.preventDefault();
      }

      return originalClick.call(this, event);
    };
  }
});

document.addEventListener('click', function (event) {
  // Check if the clicked element is a link or inside a link
  const link = event.target.closest('a');

  // If the clicked element is a link
  if (link) {
    setTimeout(() => {
      const linkTitle = link.innerText;
      const linkHref = link.getAttribute('href');
      const data = { title: linkTitle, href: linkHref };

      handleExternalLinkClick(data);
    }, 0);
  }
});
